import type * as core from '../../../../../../../core'
/* eslint-disable sort-keys */
export const query: core.mosaic.Page.Query = {
  target: 'dim::!outcomes',
  quantity: 1,
  filter: {
    and: [
      {
        '=': [
          {
            '@_': 'id',
          },
          {
            '@$': 'currentEntityId',
          },
        ],
      },
      {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'currentRecordId',
          },
        ],
      },
    ],
  },
  selection: {
    '{}': {
      title: {
        '@.': '!name',
      },
      breadcrumbs: {
        '++': [
          {
            '@': 'ancestorBreadcrumbs',
          },
        ],
      },
    },
  },
  variables: {
    currentEntityId: 'ent:!outcomes:!mission',
    currentRecordId: '?root',
  },
  subqueries: {
    ancestorBreadcrumbs: {
      target: 'ancestors',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          goto: {
            '{}': {
              variables: {
                '{}': {
                  currentEntityId: {
                    '@_': 'id',
                  },
                  currentRecordId: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
